"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["project", "companies", "departments", "offices", "secret"],

  data: function data() {
    return {
      firstname: null,
      lastname: null,
      dateOfBirth: "",
      email: null,
      company: "",
      office: "",
      department: "",
      phone: null,
      phoneWithCountry: null,
      userGender: "",
      password: null,
      confirmPassword: null,
      sid: null,
      error: false,
      interval: null,
      validationErrors: {
        firstname: [],
        lastname: [],
        email: [],
        phone: [],
        gender: [],
        company: [],
        office: [],
        department: [],
        password: [],
        confirmPassword: [],
        dateOfBirth: []
      },
      errorMessage: null,
      url: "/signup-email/",
      formStep: 1,
      confirmationCode: null,
      currentOffices: [],
      currentDepartments: [],
      isLoading: false,
      isPhoneValid: false,
      dropdownOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.subscribe(function (mutation) {
      if (mutation.type === "changeLocale") {
        var validationErrorsExists = false;

        for (var validationGroup in _this.validationErrors) {
          if (_this.validationErrors[validationGroup].length) {
            validationErrorsExists = true;
            break;
          }
        }

        if (validationErrorsExists) {
          Object.keys(_this.validationErrors).forEach(function (key) {
            return _this.validationErrors[key] = [];
          });
          _this.isFormValid();
        }
      }
    });
    this.dropdownOptions = {
      width: "100%",
      showFlags: true,
      showDialCodeInList: true
    };
  },


  methods: {
    setFirstname: function setFirstname(firstname) {
      this.firstname = firstname;
    },
    setLastname: function setLastname(lastname) {
      this.lastname = lastname;
    },
    setDateOfBirth: function setDateOfBirth(date) {
      this.dateOfBirth = moment(date).format("YYYY-MM-DD");
    },
    setPhone: function setPhone(number, details) {
      this.phoneWithCountry = details.number;
    },
    setGender: function setGender(gender) {
      this.userGender = gender;
    },
    setPassword: function setPassword(password) {
      this.password = password;
    },
    setConfirmPassword: function setConfirmPassword(confirmPassword) {
      this.confirmPassword = confirmPassword;
    },
    setEmail: function setEmail(email) {
      this.email = email;
    },
    setCompany: function setCompany(company) {
      this.company = company;
      this.setOffice("");
    },
    setOffice: function setOffice(office) {
      this.office = office;
      this.setDepartment("");
    },
    setDepartment: function setDepartment(department) {
      this.department = department;
    },
    setConfirmationCode: function setConfirmationCode(confirmationCode) {
      this.confirmationCode = confirmationCode;
    },
    authenticate: function authenticate() {
      var _this2 = this;

      if (this.formStep === 1) {
        // Clear errors object.
        Object.keys(this.validationErrors).forEach(function (key) {
          return _this2.validationErrors[key] = [];
        });

        if (!this.isFormValid()) {
          return;
        }

        this.startSigning();

        this.errorMessage = null;
        this.error = false;
      } else {
        this.confirmSigning();
        this.startAuthCheck();
      }
    },
    isFormValid: function isFormValid() {
      var _this3 = this;

      if (!this.firstname) {
        this.validationErrors.firstname.push(this.$t("sign_up.validation.firstname.empty"));
      }

      if (!this.lastname) {
        this.validationErrors.lastname.push(this.$t("sign_up.validation.lastname.empty"));
      }

      if (!this.dateOfBirth) {
        this.validationErrors.dateOfBirth.push(this.$t("sign_up.validation.date_of_birth.empty"));
      }

      if (!this.email) {
        this.validationErrors.email.push(this.$t("sign_up.validation.email.empty"));
      }

      if (this.email && !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.email.toLowerCase())) {
        this.validationErrors.email.push(this.$t("sign_up.validation.email.incorrect_format"));
      }

      if (!this.phone) {
        this.validationErrors.phone.push(this.$t("sign_up.validation.phone.empty"));
      }

      if (!this.isPhoneValid) {
        this.validationErrors.phone.push(this.$t("sign_up.validation.phone.invalid"));
      }

      if (!this.userGender) {
        this.validationErrors.gender.push(this.$t("sign_up.validation.gender.empty"));
      }

      if (this.companies.length && !this.company) {
        this.validationErrors.company.push(this.$t("sign_up.validation.company.empty"));
      }

      if (this.currentOffices.length && !this.office) {
        this.validationErrors.office.push(this.$t("sign_up.validation.office.empty"));
      }

      if (this.currentDepartments.length && !this.department) {
        this.validationErrors.department.push(this.$t("sign_up.validation.department.empty"));
      }

      if (this.password !== this.confirmPassword) {
        this.validationErrors.confirmPassword.push(this.$t("sign_up.validation.password.not_match"));
      }

      if (!this.password || this.password.length < 8) {
        this.validationErrors.password.push(this.$t("sign_up.validation.password.short"));
      }

      if (this.password) {
        // Check on uppercase existence.
        if (!(this.password.toLowerCase() != this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_uppercase"));
        }

        // Check on lowercase existence.
        if (!(this.password.toUpperCase() != this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_lowercase"));
        }

        // Check on digits existence.
        if (!/\d+/.test(this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_digit"));
        }

        // Check non-alphabetical character existence.
        if (!/\W+/.test(this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_non_alphabetical"));
        }
      }

      return Object.keys(this.validationErrors).reduce(function (accumulator, key) {
        return accumulator && !_this3.validationErrors[key].length;
      }, true);
    },
    validatePhone: function validatePhone(phone) {
      this.isPhoneValid = phone.isValid;
    },
    startSigning: function startSigning() {
      var _this4 = this;

      var toastr = this.$toastr;
      var vm = this;
      this.error = false;

      this.isLoading = true;

      axios.post(this.url + this.secret, {
        firstname: this.firstname,
        lastname: this.lastname,
        date_of_birth: this.dateOfBirth,
        email: this.email,
        phone: this.phoneWithCountry,
        gender: this.userGender.id,
        password: this.password,
        company_id: this.company ? this.company.id : null,
        office_id: this.office ? this.office.id : null,
        department_id: this.department ? this.department.id : null,
        project_guid: this.secret,
        confirmation_code: this.confirmationCode,
        locale: this.$i18n.locale
      }).then(function (res) {
        _this4.isLoading = false;

        if (res.data.user_exists) {
          toastr.options.positionClass = "toast-top-center";
          toastr.warning(_this4.$t("sign_up.messages.email_is_registered"));

          setTimeout(function () {
            window.location.replace(window.location.protocol + "//" + window.location.hostname + "/login");
          }, 2000);
          vm.stop();
        }

        //Second step transformation
        vm.formStep = 2;
        vm.url = "/confirm-signup-email/";

        vm.sid = res.data.sid;
      }).catch(function (_ref) {
        var response = _ref.response;

        vm.errorMessage = _.get(response, "data.message", _this4.$t("common.messages.unknown_error"));

        _.each(response.data.data, function (errors, input) {
          Vue.set(_this4.validationErrors, input, errors);
        });

        _this4.error = true;
        vm.stop();
      });
    },
    confirmSigning: function confirmSigning() {
      var _this5 = this;

      var vm = this;
      this.error = false;

      this.isLoading = true;

      axios.post(this.url + this.secret, {
        email: this.email,
        confirmation_code: this.confirmationCode,
        locale: this.$i18n.locale
      }).then(function (res) {
        vm.sid = res.data.sid;
      }).catch(function (error) {
        _this5.error = true;
        _this5.errorMessage = error.response.data.message;
        vm.stop();
      });
    },
    startAuthCheck: function startAuthCheck() {
      var _this6 = this;

      var vm = this;
      this.isLoading = true;
      window.setTimeout(function () {
        if (vm.error) {
          _this6.isLoading = false;
          return;
        }

        vm.interval = window.setInterval(function () {
          vm.checkIfAuthenticated();
        }, 3000);
      }, 3000);
    },
    stop: function stop() {
      clearInterval(this.interval);
      this.isLoading = false;
    },
    checkIfAuthenticated: function checkIfAuthenticated() {
      var _this7 = this;

      var vm = this;
      this.isLoading = true;
      axios.post("/auth/isauthenticated", {
        sid: this.sid,
        locale: this.$i18n.locale
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.status == "ok") {
          vm.stop();
          window.location.href = data.redirect;
        }
      }).catch(function (error) {
        _this7.error = true;
        _this7.stop();
      });
    }
  },

  computed: {
    filteredOffices: function filteredOffices() {
      var _this8 = this;

      this.currentDepartments = [];
      var currentOffices = _(this.offices).filter(function (office) {
        return office.company_id === _this8.company.id;
      }).value();
      this.currentOffices = currentOffices;

      return _.isEmpty(currentOffices) ? null : currentOffices;
    },
    filteredDepartments: function filteredDepartments() {
      var _this9 = this;

      var currentDepartments = _(this.departments).filter(function (department) {
        return department.office_id === _this9.office.id;
      }).value();
      this.currentDepartments = currentDepartments;

      return _.isEmpty(currentDepartments) ? null : currentDepartments;
    },
    gender: function gender() {
      return [{ name: this.$t("user_profile.placeholders.gender_male"), id: "male" }, {
        name: this.$t("user_profile.placeholders.gender_female"),
        id: "female"
      }];
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/SignUpFormEmail.vue
// module id = 0/G0
// module chunks = 0 1